import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { REDIRECT_AFTER_LOGIN_KEY, useGetMeQuery } from '@/store/services/authApi';

const AuthInitializer = ({ children }) => {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const isLogout = pathname === '/logout';
    const { isSuccess } = useGetMeQuery(undefined, { skip: isLogout });

    useEffect(() => {
        if (isSuccess) {
            const redirectTo = localStorage.getItem(REDIRECT_AFTER_LOGIN_KEY);
            if (redirectTo) {
                localStorage.removeItem(REDIRECT_AFTER_LOGIN_KEY);
                const url = new URL(redirectTo);
                navigate(url.pathname + url.search + url.hash, { replace: true });
            }
        }
    }, [isSuccess, navigate]);

    return isSuccess || isLogout ? children : null;
};

export { AuthInitializer };
